import React from "react";
import { IonContent, IonPage } from "@ionic/react";
import TherapiesCard from "./TherapyCard";
import { TherapiesCardProps } from "./types";
// Remove CSS import since we're using Tailwind

interface UserTherapyActivityProps {
  userTherapies: TherapiesCardProps[];
  onClick?: (therapy: TherapiesCardProps) => void;
  noDevicesPaired?: boolean;
}

const UserTherapyActivity: React.FC<UserTherapyActivityProps> = ({
  userTherapies,
  onClick,
  noDevicesPaired,
}) => {
  if (noDevicesPaired) {
    return (
      <div className="min-w-[100%] ">
        <div className=" min-w-[100%] lg:p-4 flex justify-center items-center">
          <TherapiesCard
            key={0}
            title={userTherapies[0].title}
            therapies={userTherapies[0].therapies}
            noDevicesPaired={noDevicesPaired}
            onClick={onClick}
          />
        </div>
      </div>
    );
  }
  // If there's only one therapy, render it centered
  if (userTherapies.length === 1) {
    return (
      <div className="min-w-[100%] ">
        <div className=" min-w-[100%] lg:p-4 flex justify-center items-center">
          {" "}
          {/* Control max width for better appearance */}
          <TherapiesCard
            key={0}
            title={userTherapies[0].title}
            therapies={userTherapies[0].therapies}
            onClick={onClick}
          />
        </div>
      </div>
    );
  }

  // Otherwise, use the grid layout for multiple therapies
  return (
    <div
      className="w-full p-4 justify-center m-auto"
      onClick={() => onClick && onClick(userTherapies[0])}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {userTherapies.map((therapyGroup, index) => (
          <TherapiesCard
            key={index}
            title={therapyGroup.title}
            therapies={therapyGroup.therapies}
          />
        ))}
      </div>
    </div>
  );
};

export default UserTherapyActivity;
